export default "__VITE_ASSET__CPfxXNBc__ 480w, __VITE_ASSET__CHQcM7uF__ 600w";